import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../theme';
import { useUniqueId } from '../utils/id';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { RadioElement } from './RadioElement';
import { ITEM_GAP } from './constants';
export const RadioItem = forwardRef(function RadioItem({ name, visual, icon, iconPosition = 'center', label, value, checked, onChange, onBlur, displayType, isError, fallbackStyle, bodyCopy, disabled, itemWidth, }, ref) {
    const id = useUniqueId();
    return (React.createElement(Wrapper, { htmlFor: id, checked: checked, "$displayType": displayType, "data-testid": value, "$isError": isError, "$fallbackStyle": fallbackStyle, "$disabled": disabled, "$itemWidth": itemWidth },
        visual && !icon && (React.createElement(VisualWrapper, null,
            React.createElement(Visual, { "$visualUrl": visual }))),
        !visual && icon && (React.createElement(IconWrapper, { "$iconPosition": iconPosition },
            React.createElement(Icon, { render: icon, size: 24 }))),
        React.createElement(Box, { flex: true, alignItems: "center" },
            React.createElement(RadioElement, { ref: ref, name: name, id: id, value: value, checked: checked, onChange: onChange, onBlur: onBlur, isError: isError, mr: "8px", isDisabled: disabled }),
            React.createElement(Box, null,
                React.createElement(RadioText, { "$isError": isError }, label),
                bodyCopy && (React.createElement(Box, null,
                    React.createElement(Text, { typo: "caption" }, bodyCopy)))))));
});
const VisualWrapper = styled.div `
  width: 100%;
  max-width: 120px;
  margin: 0 auto 8px;
`;
const IconWrapper = styled.div `
  display: flex;
  padding-bottom: 12px;

  ${({ $iconPosition }) => $iconPosition === 'center' &&
    css `
      justify-content: center;
    `}

  ${({ $iconPosition }) => $iconPosition === 'start' &&
    css `
      justify-content: flex-start;
    `}
`;
const Visual = styled.div `
  width: 100%;
  padding-top: 100%;
  background-image: url('${(p) => p.$visualUrl}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;
const Wrapper = styled.label `
  display: flex;
  flex-direction: column;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? '0.5' : '1')};
  ${({ $displayType, checked, $isError, $fallbackStyle, $disabled, $itemWidth, }) => css `
    ${($displayType === 'horizontal-card' ||
    $displayType === 'vertical-card') &&
    css `
      border-radius: 12px;
      background-color: ${$fallbackStyle
        ? theme.colors.cream
        : theme.colors.custard};
      padding: ${checked ? '10px' : '12px'};
      border: ${checked &&
        ($isError
            ? `2px solid ${theme.colors.strawberry}`
            : `2px solid ${theme.colors.liquorice}`)};

      &:hover {
        ${!$disabled &&
        css `
          background-color: ${$fallbackStyle
            ? theme.colors.coconut
            : theme.colors.oatmeal};
        `}
      }
    `}
    ${$displayType === 'horizontal-card' &&
    css `
      justify-content: center;
      ${!$itemWidth &&
        css `
        @media (min-width: 420px) {
          width: calc(50% - ${ITEM_GAP / 2}px);
        }

        @media (min-width: 768px) {
          width: 201px;
        }
      `}
    `}
  width: ${$itemWidth ?? '100%'};
  `}
`;
const RadioText = styled.span `
  line-height: 16px;
  font-size: 16px;
  font-weight: ${theme.font.weight.medium};
  color: ${({ $isError }) => $isError ? theme.colors.strawberry : theme.colors.liquorice};
  margin-top: 4px;
`;
//# sourceMappingURL=RadioItem.js.map